export enum LetterTypeEnum {
  Academic = 0,
  Disciplinary = 1,
}
